"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageType = exports.CustomPizza = void 0;
var CustomPizza;
exports.CustomPizza = CustomPizza;

(function (CustomPizza) {
  CustomPizza["CustomPizzaCode"] = "CUS";
  CustomPizza["CustomPizzaDescription"] = "create-your-own-pizza";
})(CustomPizza || (exports.CustomPizza = CustomPizza = {}));

var ImageType;
exports.ImageType = ImageType;

(function (ImageType) {
  ImageType["CustomImage"] = "Web_CustomBanner";
  ImageType["MenuImage"] = "Web_MenuImage";
  ImageType["ItemDetailImage"] = "Web_ItemDetailImage";
})(ImageType || (exports.ImageType = ImageType = {}));